import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { active_img, deactive_img, delete_icon, edit_icon, eye_icon, password_icon, search_icon, toggle_off, toggle_on, view_icon } from '../../assets/imgs';
import { useNavigate } from 'react-router-dom';
import { admin_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import { useAdminAddMutation, useAdminDeleteMutation, useAdminListMutation, useLazyAdminListQuery, useLazyAdminListStatusQuery, useLazyAdminListViewQuery } from '../redux/api/api';
import { toast } from 'react-toastify';

const AdminList = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState()

  const [adminListApi] = useAdminListMutation();
  const [adminListStatus] = useLazyAdminListStatusQuery();
  const [adminListDelete] = useAdminDeleteMutation();


  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))



  const adminList = (page, search) => {
    const formdata = new FormData();
    formdata.append("page", page)
    formdata.append("row", 10)
    if (search) {
      formdata.append('search', search)
    }
    adminListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = []
        res?.admins?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        setCount(res?.pagination?.total);
        setPagecount(res?.pagination)
      })
      .catch((err) => {
        console.log("err", err);
      })
  }


  const adminStatus = (id) => {
    adminListStatus(id)
      .unwrap()
      .then((res) => {
        console.log("reasds", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          adminList()
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }
  const adminDelete = (id) => {
    const formdata = new FormData();
    formdata.append("_method", "DELETE");
    adminListDelete({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          setDeletePopup(false);
          adminList();
        } else if (res?.status == "error") {
          setDeletePopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    adminList(pageno)
  }, [pageno]);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Admin Id",
        accessor: "admin_id",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Admin",
        accessor: "username",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p>{value?.role}</p>;
        },
      },


      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <select disabled={rolePermissions?.includes('CAN-STATUS-ADMIN') ? false : true}
                value={value}
                onChange={() => { adminStatus(row.original.id) }}
                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1 ? "active-btn" : "suspend-btn"}`}
              >
                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1}>
                  Active
                </option>
                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={0}>
                  Deactive
                </option>
              </select>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-VIEW-ADMIN') &&
                  <button
                    onClick={() => navigate("/admin-add", { state: { id: row.original.id, type: "view" } })}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                }
                {rolePermissions?.includes('CAN-EDIT-ADMIN') &&
                  <button
                    onClick={() => navigate("/admin-add", { state: { id: row.original.id, type: "edit" } })}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn" />
                  </button>
                }
                {rolePermissions?.includes('CAN-DELETE-ADMIN') &&
                  <button
                    onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                }
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView home_section" >
      <div className='d-flex ac-jb'>
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Admins({count})
        </h2>
        <div className='d-flex gap-3'>
          < div className='search-input'>
            <input onChange={(e) => (adminList(1, e.target.value))} type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
            <img src={search_icon} className='search' />
          </div>
          {rolePermissions?.includes('CAN-ADD-ADMIN') &&
            <button onClick={() => navigate('/admin-add')} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add Admin</button>}
        </div>
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                Admin List
              </h2>
              <button
                onClick={() => setPopup(false)}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=" Name"
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Phone Number
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              placeholder="Phone Number"
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Email
            </h4>
            <input
              type="email"
              className="input-pop ps-2 w-100"
              placeholder=" Email Address"
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Roles
            </h4>
            <select className="input-pop ps-2 w-100">
              <option> User</option>
              <option> Device</option>
              <option> Location</option>
            </select>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Password
            </h4>
            <div className="input-pop mb-2 w-100 d-flex ac-jb">
              <input
                type={visible ? "text" : "password"}
                maxLength={20}
                className="cust-btn  w-90"
                placeholder="Password"
              />
              <img
                src={eye_icon}
                onClick={() => setVisible(!visible)}
                className="eye-icon pointer"
                alt=""
              />
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Confirm Password
            </h4>
            <div className="input-pop mb-2 w-100 d-flex ac-jb">
              <input
                type={visible ? "text" : "password"}
                maxLength={20}
                className="cust-btn w-90"
                placeholder=" Confirm Password"
              />
              <img
                src={eye_icon}
                onClick={() => setVisible(!visible)}
                className="eye-icon pointer"
                alt=""
              />
            </div>
            <div className="d-flex ac-jc">
              <button onClick={() => setPopup(false)} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setDeletePopup(false)} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  adminDelete(deletePopup);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
    </div>
  );
};

export default AdminList
